import { render } from "./Appointment.vue?vue&type=template&id=57485a35"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"
script.render = render

export default script